// extracted by mini-css-extract-plugin
export default {"fullWidth":"e8L0lPQ7wYacieRhPI0u"};